import React from "react";
import styled from "styled-components";
import { styles } from "../utils/theme";
import dayjs from "dayjs";

const PastEventCard = ({ event }) => {
  return (
    <StyledEventCard>
      <CardContainer>
        <ContentWrapper>
          <ImageSection>
            <CardImage>
              <img
                src={
                  !!event.thumbnail
                    ? event.thumbnail
                    : "/assets/images/event/placeholder.png"
                }
                alt={event.title}
                className="w-100"
                height={300}
                width={300}
              />
            </CardImage>
          </ImageSection>
          <EventContent>
            <h3 className="fw-700 lh-3 font-xsss">{event.title}</h3>
            <span className="d-flex font-xssss fw-500 mt-2 lh-3 text-grey-500">
              <i className="ti-calendar me-1"></i>
              {dayjs.unix(event.endDate).format("DD MMM YYYY")}
            </span>
          </EventContent>
        </ContentWrapper>
      </CardContainer>
    </StyledEventCard>
  );
};

const StyledEventCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: rgb(247, 246, 242);
  padding: 1.5rem;
  border-radius: ${styles.card_border_radius};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const CardContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
`;

const ContentWrapper = styled.div`
  position: relative;
  transition: transform 0.3s ease-in-out;
`;

const ImageSection = styled.div`
  position: relative;
  height: 100px;
`;

const CardImage = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100px;
  border-radius: ${styles.card_border_radius};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: grayscale(100%) contrast(60%);
    transition: transform 0.3s ease-out;
    pointer-events: none;
    user-select: none;
  }
`;

const EventContent = styled.div`
  display: flex;
  flex-direction: column;

  h3 {
    margin: 12px 0 0;
  }
`;

export default PastEventCard;
